export default {
    "TXT_APP_Back": "返回",
    "TXT_APP_By": "由",
    "TXT_APP_Continue": "继续",
    "TXT_APP_Currency_HKD": "港元",
    "TXT_APP_Currency_RMB": "人民币",
    "TXT_APP_Currency_USD": "美元",
    "TXT_APP_NA": "不适用",
    "TXT_APP_Not_Support_IE": "您的浏览器不受支持。请使用Chrome、Edge、Firefox、Safari或QQ浏览器浏览我们的页面。谢谢。",
    "TXT_APP_Please_Wait": "请稍候，请勿关闭浏览器。",
    "TXT_APP_Remove": "移除",
    "TXT_APP_Submit": "提交",
    "TXT_CHINESE_PAYMENT_NOTIFY": "请注意，交易正在进行中，可能需要比预期更长的时间才能完成。请耐心等待页面跳转，并确保不要关闭支付应用程序及支付页面。",
    "TXT_ERROR_Client_Side_Error": "客户端发生错误",
    "TXT_ERROR_Create_Order": "请重试或稍后再试。",
    "TXT_ERROR_Expired_Package_Not_Allow_To_Pay": "产品链接已不再可用。\n请联系您的销售代表或致电 (852) 1830 668。",
    "TXT_ERROR_Form_Address_First_Row_Invalid": "输入无效，必须提供英文地址。",
    "TXT_ERROR_Form_Address_First_Row_Missing": "请填写第一行的地址。",
    "TXT_ERROR_Form_Address_Fourth_Row_Invalid": "输入无效，必须提供英文地址。",
    "TXT_ERROR_Form_Address_Missing": "请填写公司地址 (英文)。",
    "TXT_ERROR_Form_Address_Second_Row_Invalid": "输入无效，必须提供英文地址。",
    "TXT_ERROR_Form_Address_Third_Row_Invalid": "输入无效，必须提供英文地址。",
    "TXT_ERROR_Form_BR_Commencement_Date_Missing": "请选择开始日期。",
    "TXT_ERROR_Form_BR_Expiry_Date_Missing": "请选择到期日期。",
    "TXT_ERROR_Form_BR_Image_Missing": "请上传营业执照。",
    "TXT_ERROR_Form_BR_Number_Missing": "请填写统一社会信用代码。",
    "TXT_ERROR_Form_Contact_Person_FN_Invalid": "输入无效，必须提供英文姓名。",
    "TXT_ERROR_Form_Contact_Person_LN_Invalid": "输入无效，必须提供英文姓名",
    "TXT_ERROR_Form_Contact_Person_Missing": "请填写联系人称谓/姓名。",
    "TXT_ERROR_Form_Email_Invalid": "无效的公司电邮。",
    "TXT_ERROR_Form_Email_Lang_Pref": "请选择电邮语言偏好。",
    "TXT_ERROR_Form_Email_Missing": "请填写公司电邮。",
    "TXT_ERROR_Form_General_Invalid": "提供的值无效。",
    "TXT_ERROR_Form_HKBR_Number_Invalid": "无效的统一社会信用代码。只允许字符 ，最多20个字符。",
    "TXT_ERROR_Form_NOB_Missing": "请选择业务性质。",
    "TXT_ERROR_Form_NOT_HKBR_Number_Invalid": "无效的统一社会信用代码。最多20个字符。",
    "TXT_ERROR_Form_Name_EN_Invalid": "公司名称无效 (英文)。",
    "TXT_ERROR_Form_Name_EN_Missing": "请填写公司名称 (英文)。",
    "TXT_ERROR_Form_Name_SC_Invalid": "无效的公司名称 (简体中文)。",
    "TXT_ERROR_Form_Name_TC_Invalid": "无效的公司名称 (繁体中文)。",
    "TXT_ERROR_Form_No_Package_Hashed_ID_Specified": "未指定套餐哈希ID",
    "TXT_ERROR_Form_No_Sales_Channel_Specified": "未指定销售渠道",
    "TXT_ERROR_Form_Recaptcha_Not_Checked": "验证失败。",
    "TXT_ERROR_Form_Region_City_Invalid": "所选城市与所选省份不符",
    "TXT_ERROR_Form_Region_Country_Missing": "请选择国家/地区。",
    "TXT_ERROR_Form_Region_Mandatory_City_Missing": "请选择城市。",
    "TXT_ERROR_Form_Region_Mandatory_State_Missing": "请选择州/省。",
    "TXT_ERROR_Form_Region_State_Invalid": "所选州份与所选国家不符",
    "TXT_ERROR_Form_Sales_Rep_Code_Invalid": "无效的销售代表代码。",
    "TXT_ERROR_Form_Telephone_Area_Cod_Invalid": "无效的电话号码。",
    "TXT_ERROR_Form_Telephone_Ext_Invalid": "无效的电话号码。",
    "TXT_ERROR_Form_Telephone_Field_Missing": "请填写您的电话号码。",
    "TXT_ERROR_Form_Telephone_Number_Invalid": "无效的电话号码。",
    "TXT_ERROR_Form_TnC_Missing": "您必须阅读并同意我们的使用条款才能继续。",
    "TXT_ERROR_General_Error": "我们遇到了一些技术问题，请稍后重试。\n如有任何疑问，请致电 (852) 1830 668。",
    "TXT_ERROR_Load_Order": "我们遇到了一些技术问题，请稍后重试。\n如有任何疑问，请致电 (852) 1830 668。",
    "TXT_ERROR_Load_Package_With_Error": "我们遇到了一些技术问题，请稍后重试。\n如有任何疑问，请致电 (852) 1830 668。",
    "TXT_ERROR_Not_Able_To_Pay": "我们遇到了一些技术问题，请稍后重试。\n如有任何疑问，请致电 (852) 1830 668。",
    "TXT_ERROR_Order_Status_Not_Allow_To_Pay": "订单已被取消或拒绝。请致电 (852) 1830 668 或邮件至 online.ordering@hktdc.org",
    "TXT_ERROR_Package_Disabled": "产品链接已不再可用。\n请联系您的销售代表或致电 (852) 1830 668。",
    "TXT_ERROR_Package_Expired": "产品链接已不再可用。\n请联系您的销售代表或致电 (852) 1830 668。",
    "TXT_ERROR_Package_Not_Yet_Start": "产品链接已不再可用。\n请联系您的销售代表或致电 (852) 1830 668。",
    "TXT_ERROR_Page_Not_Found": "404 - 找不到页面",
    "TXT_ERROR_Payment_Gateway_Error": "很抱歉，支付网关目前无法完成您的付款。请稍后重新提交您的订单。如有其他查询，请致电我们的客户服务热线 (852) 1830 668 或电邮至 online.ordering@hktdc.org",
    "TXT_ERROR_Payment_Gateway_Query_Payment_Status_Failed": "谢谢您的订购。我们将核实您的付款并很快向您发送确认邮件。\n如有任何疑问，请致电 (852) 1830 668",
    "TXT_ERROR_Server_Side_Error": "服务器发生<statusCode>错误",
    "TXT_ERROR_Update_Order": "请重试或稍后再试。",
    "TXT_ERROR_User_Block_Popup": "请停用弹出窗口阻止程序并重新点击超链接。",
    "TXT_LANDING_Agree_Desc": "我同意除非我取消自动续约，否则已订阅的套餐将在目前订阅期届满前代表我自动续约。",
    "TXT_LANDING_Company_Info": "公司资料",
    "TXT_LANDING_Confirm_Payment_Message": "根据我们的记录，我们已收到您的全额付款，确认邮件将很快发送给您。",
    "TXT_LANDING_Confirm_Privacy_Policy_Statement": "隐私政策声明",
    "TXT_LANDING_Confirm_Proceed_Payment_Btn": "确认并进行付款",
    "TXT_LANDING_Confirm_Terms_And_Conditions_For_HKTDC": "香港贸发局广告、广告相关服务及活动现场广告项目的条款及细则",
    "TXT_LANDING_Confirm_Terms_Of_Use": "使用条款",
    "TXT_LANDING_Confirm_Terms_Of_Use_And_Symbol": "及",
    "TXT_LANDING_Confirm_Terms_Of_Use_Link_Text1": "http://www.hktdc.com/mis/tu/en/Terms-of-Use.html",
    "TXT_LANDING_Confirm_Terms_Of_Use_Link_Text2_Part1": "info.hktdc.com/",
    "TXT_LANDING_Confirm_Terms_Of_Use_Link_Text2_Part2": "promotion_terms/index.htm",
    "TXT_LANDING_Confirm_Terms_Part1": "我确认已阅读并同意香港贸易发展局(香港贸发局)的",
    "TXT_LANDING_Confirm_Terms_Part2": "，并确认上述资料可由香港贸发局纳入其全部或任何资料库，用作直接营销或商业配对目的，以及",
    "TXT_LANDING_Done_Btn": "完成",
    "TXT_LANDING_Done_Btn_Url": "https://sourcingsupport.hktdc.com/hc/zh-cn",
    "TXT_LANDING_Fields_BR_Number": "统一社会信用代码",
    "TXT_LANDING_Fields_Commencement_Date": "开始日期 (请选择最早可选日期)",
    "TXT_LANDING_Fields_Email": "公司电邮",
    "TXT_LANDING_Fields_Expiry_Date": "到期日期 (请选择最晚可选日期)",
    "TXT_LANDING_Fields_Name": "公司名称 (英文名称)",
    "TXT_LANDING_Fields_Name_SC": "公司名称 (简体中文)",
    "TXT_LANDING_Fields_Name_TC": "公司名称 (繁体中文)",
    "TXT_LANDING_Fields_Provide_BR_Details": "现在可提供营业执照详情",
    "TXT_LANDING_Fields_Provide_BR_Details_Msg": "您亦可在订购套餐之后补回营业执照详情及上传营业执照。",
    "TXT_LANDING_From_Address_En": "公司地址 (英文地址)",
    "TXT_LANDING_From_City": "城市",
    "TXT_LANDING_From_Contact_Person_Name": "联系人姓名 (请输入英文姓名)",
    "TXT_LANDING_From_Desc1": "请填写订购表格。",
    "TXT_LANDING_From_Desc2": "如果您是由我们的销售代表转介，请在下方输入销售代表代码。",
    "TXT_LANDING_From_Email_Lang_Option": "电邮语言偏好",
    "TXT_LANDING_From_Nature_Of_Business": "业务性质",
    "TXT_LANDING_From_Region": "国家/地区",
    "TXT_LANDING_From_Sales_Code": "销售代表代码",
    "TXT_LANDING_From_State": "州/省",
    "TXT_LANDING_From_Tel": "电话",
    "TXT_LANDING_Hints_Required": "必填资料",
    "TXT_LANDING_Logo_Link_Url": "https://sourcing.hktdc.com/zh-Hans",
    "TXT_LANDING_Media_Modal_Title": "查看已上传的营业执照",
    "TXT_LANDING_Modal_Acceptable": "只接受JPG和PDF文件。文件大小最大2MB。",
    "TXT_LANDING_Modal_Cancel_Upload": "取消上传",
    "TXT_LANDING_Modal_Choose_File": "选择文件",
    "TXT_LANDING_Modal_Contact_Message": "您的付款交易无法完成。\n请致电 (852) 1830 668 或邮件至\nonline.ordering@hktdc.org",
    "TXT_LANDING_Modal_Drap_N_Drop": "或拖放文件",
    "TXT_LANDING_Modal_Message_Upload_Failed": "只接受JPG, JPEG和PDF档案，且档案大小必须少于2MB。请再试一次。",
    "TXT_LANDING_Modal_Upload_Again": "重新上传",
    "TXT_LANDING_Modal_Upload_Failed": "上传失败",
    "TXT_LANDING_Modal_Uploading": "上传中...",
    "TXT_LANDING_Modal_Verify_Card_Message": "您的付款交易无法完成。\n请核实您的信用卡详情并重试。",
    "TXT_LANDING_Ok_Btn_Title": "确定",
    "TXT_LANDING_Order_ID_Display": "订单编号",
    "TXT_LANDING_PH_Address_Unit": "房间 / 单位 / 楼层 / 座",
    "TXT_LANDING_PH_Area_Code": "区号 (如有)",
    "TXT_LANDING_PH_BR_Number": "统一社会信用代码",
    "TXT_LANDING_PH_Building": "大厦",
    "TXT_LANDING_PH_City": "区 / 市 / 州 / 省 / 国家",
    "TXT_LANDING_PH_Date": "日日 月月 年年年年",
    "TXT_LANDING_PH_Email": "公司电邮",
    "TXT_LANDING_PH_Extension": "分机 (如有)",
    "TXT_LANDING_PH_First_Name": "名",
    "TXT_LANDING_PH_Last_Name": "姓",
    "TXT_LANDING_PH_Name": "公司名称 (英文)",
    "TXT_LANDING_PH_Name_SC": "公司名称 (简体中文)",
    "TXT_LANDING_PH_Name_TC": "公司名称 (繁体中文)",
    "TXT_LANDING_PH_Select": "请选择",
    "TXT_LANDING_PH_Street": "街道 / 道路",
    "TXT_LANDING_PH_Tel_Number": "电话号码",
    "TXT_LANDING_Package_Details": "套餐详情",
    "TXT_LANDING_Package_Period_Month": "个月",
    "TXT_LANDING_Package_Period_Month_Lower_Letter": "个月",
    "TXT_LANDING_Package_Period_Months": "个月",
    "TXT_LANDING_Package_Period_Months_Lower_Letter": "个月",
    "TXT_LANDING_Package_Prices_Notice": "价格因国家或地区而异",
    "TXT_LANDING_Package_View_More": "查看套餐详情",
    "TXT_LANDING_Page_Title": "订购网上推广计划",
    "TXT_LANDING_Payment_Failed_Modal_Title": "付款失败",
    "TXT_LANDING_Payment_Link_Expired": "付款链接已过期。",
    "TXT_LANDING_Payment_Method": "付款方式",
    "TXT_LANDING_Please_Call_Us_Message": "请致电 (852) 1830 668 或邮件至 online.ordering@hktdc.org",
    "TXT_LANDING_Privacy_Policy_Statement_Link_Url": "http://www.hktdc.com/mis/pps/en/Privacy-Policy-Statement.html",
    "TXT_LANDING_Proceed_Payment_Btn": "进行付款",
    "TXT_LANDING_Sales_Contact_Message": "您的专属销售代表将很快与您联系。",
    "TXT_LANDING_Scheduled_Payment_Message": "我们已收到您的预定付款指示，邮件通知将很快发送给您。",
    "TXT_LANDING_Subscription_Approved_Desc": "谢谢您的付款。您的订购正等待核实。",
    "TXT_LANDING_Summary_Form_Proceed_Btn": "进行付款",
    "TXT_LANDING_Summary_From_BRN": "统一社会信用代码",
    "TXT_LANDING_Summary_From_Commencement_Date": "开始日期",
    "TXT_LANDING_Summary_From_Currency_Paid_Way": "付款货币",
    "TXT_LANDING_Summary_From_Exchange_Rate_Desc": "**汇率可能会有变动**",
    "TXT_LANDING_Summary_From_Expiry_Date": "到期日期",
    "TXT_LANDING_Summary_From_Title": "订单摘要",
    "TXT_LANDING_Summary_From_Total_Amount": "总付款金额",
    "TXT_LANDING_Summary_Payment_Details_Currency": "HKD",
    "TXT_LANDING_Term_Of_Use_Link_Url1": "http://www.hktdc.com/mis/tu/en/Terms-of-Use.html",
    "TXT_LANDING_Term_Of_Use_Link_Url2": "http://info.hktdc.com/promotion_terms/index.htm",
    "TXT_LANDING_Thankyou_Currency_Paid_Way": "付款货币",
    "TXT_LANDING_Timer_Modal_Title": "超时",
    "TXT_LANDING_Unavailable_Page_Here": "这里",
    "TXT_LANDING_Unavailable_Page_Prefix": "页面不可用。请点击",
    "TXT_LANDING_Unavailable_Page_Suffix": "再次提交您的订单。",
    "TXT_LANDING_Upload_Constraint": "上传营业执照 (最大 2MB)",
    "TXT_ONLINE_FORM_Aria_Label_Appellation_Select_Input": "称谓选择清单",
    "TXT_ONLINE_FORM_Aria_Label_BR_Cancel_Upload_Input": "取消上传文件",
    "TXT_ONLINE_FORM_Aria_Label_BR_Choose_Files_Input": "选择营业执照",
    "TXT_ONLINE_FORM_Aria_Label_BR_Commencement_Date_Input": "输入营业执成立日期",
    "TXT_ONLINE_FORM_Aria_Label_BR_Details_Remove_Uploaded_Files_Btn": "移除已上传文件",
    "TXT_ONLINE_FORM_Aria_Label_BR_Details_Switch_Btn": "开启/关闭营业执照部分",
    "TXT_ONLINE_FORM_Aria_Label_BR_Details_Upload_Files_Btn": "上传营业执照",
    "TXT_ONLINE_FORM_Aria_Label_BR_Expiry_Date_Input": "输入营业执照到期日期",
    "TXT_ONLINE_FORM_Aria_Label_BR_Number_Input": "输入统一社会信用代码",
    "TXT_ONLINE_FORM_Aria_Label_Company_Address_Row1_Input": "输入地址房间/单位/楼层/座",
    "TXT_ONLINE_FORM_Aria_Label_Company_Address_Row2_Input": "输入地址大厦",
    "TXT_ONLINE_FORM_Aria_Label_Company_Address_Row3_Input": "输入地址街道/道路",
    "TXT_ONLINE_FORM_Aria_Label_Company_Address_Row4_Input": "输入地址区/市/州/省/国家",
    "TXT_ONLINE_FORM_Aria_Label_Company_City_Input": "城市选单",
    "TXT_ONLINE_FORM_Aria_Label_Company_Email_Input": "输入电邮",
    "TXT_ONLINE_FORM_Aria_Label_Company_Name_EN_Input": "输入英文公司名称",
    "TXT_ONLINE_FORM_Aria_Label_Company_Name_SC_Input": "输入简体中文公司名称",
    "TXT_ONLINE_FORM_Aria_Label_Company_Name_TC_Input": "输入繁体中文公司名称",
    "TXT_ONLINE_FORM_Aria_Label_Company_Region_Input": "地区选择清单",
    "TXT_ONLINE_FORM_Aria_Label_Company_State_Input": "州选择清单",
    "TXT_ONLINE_FORM_Aria_Label_Contact_Sale_Popup": "付款失败并联系销售",
    "TXT_ONLINE_FORM_Aria_Label_Details_Back_Btn": "返回首页",
    "TXT_ONLINE_FORM_Aria_Label_Details_Google_Recaptcha": "验证码",
    "TXT_ONLINE_FORM_Aria_Label_Details_Preview_File_Popup": "预览文件弹窗",
    "TXT_ONLINE_FORM_Aria_Label_Details_Submit_Form_Btn": "提交表格",
    "TXT_ONLINE_FORM_Aria_Label_Details_Tencent_Captcha": "腾讯验证码",
    "TXT_ONLINE_FORM_Aria_Label_Details_Upload_Fail_Popup": "上传失败弹窗",
    "TXT_ONLINE_FORM_Aria_Label_Details_Upload_File_Popup": "上传文件弹窗",
    "TXT_ONLINE_FORM_Aria_Label_Email_Lang_Ref_Input": "电邮语言选择清单",
    "TXT_ONLINE_FORM_Aria_Label_Failure_Back_Btn": "返回摘要页面",
    "TXT_ONLINE_FORM_Aria_Label_Failure_Confirm_Btn": "处理并确认付款",
    "TXT_ONLINE_FORM_Aria_Label_First_Name_Input": "输入名字",
    "TXT_ONLINE_FORM_Aria_Label_Header_Logo": "链接至贸发局网站",
    "TXT_ONLINE_FORM_Aria_Label_Landing_Continue_Btn": "继续按钮",
    "TXT_ONLINE_FORM_Aria_Label_Last_Name_Input": "输入姓氏",
    "TXT_ONLINE_FORM_Aria_Label_NOB_Input": "业务性质选择清单",
    "TXT_ONLINE_FORM_Aria_Label_Phone_Area_Code_Input": "输入电话区号",
    "TXT_ONLINE_FORM_Aria_Label_Phone_Country_Code_Input": "电话国家代码选择清单",
    "TXT_ONLINE_FORM_Aria_Label_Phone_Extension_Input": "输入电话分机",
    "TXT_ONLINE_FORM_Aria_Label_Phone_Number_Input": "输入电话号码",
    "TXT_ONLINE_FORM_Aria_Label_Retry_Payment_Popup": "付款失败并重试",
    "TXT_ONLINE_FORM_Aria_Label_Sales_Code_Input": "输入销售代码",
    "TXT_ONLINE_FORM_Aria_Label_Summary_Back_Btn": "返回详情页面",
    "TXT_ONLINE_FORM_Aria_Label_Summary_Confirm_Btn": "处理并确认付款",
    "TXT_ONLINE_FORM_Aria_Label_Thankyou_Done_Btn": "付款完成",
    "TXT_ONLINE_FORM_Meta_Description_Title_Contact_Sale": "SPCS网上订阅表格 - 联系销售",
    "TXT_ONLINE_FORM_Meta_Description_Title_Details": "SPCS网上订阅表格 - 详细资料",
    "TXT_ONLINE_FORM_Meta_Description_Title_Discount_Listing": "SPCS管理员门户 - 折扣清单",
    "TXT_ONLINE_FORM_Meta_Description_Title_Error": "SPCS网上订阅表格 - 错误",
    "TXT_ONLINE_FORM_Meta_Description_Title_Failure": "SPCS网上订阅表格 - 错误",
    "TXT_ONLINE_FORM_Meta_Description_Title_Gen_link": "SPCS管理员门户 - 生成私人链接",
    "TXT_ONLINE_FORM_Meta_Description_Title_Index": "SPCS网上订阅表格 - 基本资料",
    "TXT_ONLINE_FORM_Meta_Description_Title_Order_Management": "SPCS管理员门户 - 订单管理",
    "TXT_ONLINE_FORM_Meta_Description_Title_Product_Listing": "SPCS管理员门户 - 产品清单",
    "TXT_ONLINE_FORM_Meta_Description_Title_Summary": "SPCS网上订阅表格 - 订单摘要",
    "TXT_ONLINE_FORM_Meta_Description_Title_Thankyou": "SPCS网上订阅表格 - 谢谢",
    "TXT_ONLINE_FORM_Meta_Description_Title_User_Management": "SPCS管理员门户 - 用户账户管理",
    "TXT_ONLINE_FORM_Meta_Head_Description": "SPCS网上订阅表格 - 基本资料",
    "TXT_ONLINE_FORM_Meta_Head_Title": "香港贸发局网上表格",
    "TXT_ONLINE_FORM_Meta_Head_Title_Contact_Sale": "联系销售",
    "TXT_ONLINE_FORM_Meta_Head_Title_Details": "详细资料",
    "TXT_ONLINE_FORM_Meta_Head_Title_Error": "错误",
    "TXT_ONLINE_FORM_Meta_Head_Title_Failure": "付款失败",
    "TXT_ONLINE_FORM_Meta_Head_Title_Index": "基本资料",
    "TXT_ONLINE_FORM_Meta_Head_Title_Summary": "订单摘要",
    "TXT_ONLINE_FORM_Meta_Head_Title_Thankyou": "谢谢",
    "TXT_SUBSCRIPTION_Page_Title": "谢谢您的订单！",
    "TXT_Summary_From_Contact_Person_Name": "联系人姓名 (英文姓名)",
    "TXT_WF_User_TnC_Html": "我/我们同意并确认，本合同、下文所定义的条款及细则，以及我/我们就上述香港贸发局活动所签署或提交的所有后续文件，对我/我们均具有约束力。本合同须经香港贸发局接受及确认，香港贸发局拥有绝对酌情权。我/我们确认并同意，香港贸发局可将上述信息用于纳入其全部或任何数据库，用于直接推广或商务配对之用，并用于隐私政策声明中所述的任何其他用途。</br></br>\n <strong>条款及细则：</strong></br>\n <ol class=\"custom-list\"> \n <li>香港贸发局广告、相关广告服务及活动现场广告项目的条款及细则（香港贸发局可不时修订或补充），详见附件及香港贸发局网站 <a href=\"https://home.hktdc.com/sc/s/sourcing-promotion-terms\" target=\"_blank\">https://home.hktdc.com/sc/s/sourcing-promotion-terms</a>；</li> \n <li>香港贸发局展览会现场广告项目申请条款（香港贸发局可不时修订或补充），详见附件及香港贸发局网站 <a href=\"https://info.hktdc.com/sourcing/onsite-ad-application-terms/\" target=\"_blank\">https://info.hktdc.com/sourcing/onsite-ad-application-terms/</a>；</li> <li>申请条款及展览规则与规定（香港贸发局可不时修订或补充），详见香港贸发局网站 <a href=\"https://exhmultifairs.hktdc.com/exh/Rules_and_Regulations/index.html\" target=\"_blank\">https://exhmultifairs.hktdc.com/exh/Rules_and_Regulations/index.html</a>；及</li> <li>香港贸发局网站(<a href=\"https://www.hktdc.com/\" target=\"_blank\">https://www.hktdc.com/</a>)上的任何其他条款及细则（香港贸发局可不时修订或补充）</li> \n </ol> \n </br>((i) 至 (iv) 统称为「<strong>条款及细则</strong>」)"
};